<template>
  <div class="se-tablerow t-darker-grey">
    <div class="se-tablerow__cells">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TableRow',
  data () {
    return {
      data: this.$parent.$props
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import '../scss/vars';
.se-tablerow {
  display: flex;
  flex-flow: column;
  width: 100%;
  margin-bottom: 40px;
  // border: 0.5px solid $table-border;
  // border-bottom: none;
  @media (min-width: 768px) {
    margin-bottom: 0;
    .se-tablecell__column-header {
      display: none;
    }
    &:first-child .se-tablecell__column-header {
      display: flex;
    }
    // &:first-child .se-tablecell__content {
    //   margin-top: 37px;
    //   height: calc(100% - 37px);
    // }
  }
  &__cells {
    display: flex;
    flex-flow: row wrap;
    // border: 0.5px solid $table-border;
    // border-bottom: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/TableRow.vue